const get = (arg_key) => {
  if (typeof document !== 'undefined') {

    if (!arg_key) {
      return
    }

    var match = document.cookie.match(new RegExp('(^| )' + (process.env.VUE_APP_ID + '__' + arg_key) + '=([^;]+)'))

    if (match) {
      return match[2]
    }
  }
}

const set = (arg_key, arg_value, arg_time = null) => {
  if (typeof document !== 'undefined') {

    if (!arg_key || !arg_value) {
      return
    }

    document.cookie = `${process.env.VUE_APP_ID + '__' + arg_key}=${arg_value};max-age=${arg_time || (60 * 60 * 24 * 365 * 10)};path=/`
  }
}

const remove = (arg_key) => {
  if (typeof document !== 'undefined') {

    if (!arg_key) {
      return
    }

    document.cookie = `${process.env.VUE_APP_ID + '__' + arg_key}=;max-age=0;path=/`
  }
}

export default {
  get,
  set,
  remove,
}